import { Button, Space, Tooltip } from "antd";
import styles from "./KeywordCloud.module.scss";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const GranularityZoomButtons = ({
  keywords,
  granularityLevel,
  setGranularityLevel,
  selectedKeywords,
  setSelectedKeywords,
  selectedKeywordsQueue,
  setSelectedKeywordsQueue,
  granularityLevelQueue,
  setGranularityLevelQueue,
  isLoading,
  cannotZoomInfoShow,
}) => {
  const maxValue = 5;
  const minValue = 1;
  const step = 1;

  const isAtMax =
    granularityLevel === maxValue ||
    Math.max(...selectedKeywords.map((item) => item.level)) + 1 == maxValue;
  const isAtMin = granularityLevel === minValue;
  const isNoKeywordLeft =
    keywords.filter((item) => {
      if (selectedKeywordsQueue[selectedKeywordsQueue.length - 2]) {
        return !selectedKeywordsQueue[selectedKeywordsQueue.length - 2]
          .map((kw) => kw.text)
          .includes(item.value);
      } else {
        return true;
      }
    }).length === 0;

  const temporaryDisableButton = () => {};

  const handleIncrease = () => {
    if (selectedKeywords.length > 0) {
      var currentMaxGranularityLevel =
        Math.max(...selectedKeywords.map((item) => item.level)) + 1;
      setGranularityLevelQueue([...granularityLevelQueue, granularityLevel]);
      // console.log("current max granularity level", currentMaxGranularityLevel, selectedKeywords);

      setTimeout(() => {
        if (currentMaxGranularityLevel < maxValue) {
          setGranularityLevel(currentMaxGranularityLevel + step);
        }
      }, 100);

      temporaryDisableButton();

      setSelectedKeywordsQueue([...selectedKeywordsQueue, selectedKeywords]);
      // setSelectedKeywords([]);
    } else {
      cannotZoomInfoShow();
    }
  };

  const handleDecrease = () => {
    // var currentMinGranularityLevel = Math.min(...selectedKeywordsQueue[selectedKeywordsQueue.length - 1].map(item => item.level)) + 1 + step;

    // console.log("current min granularity level", currentMinGranularityLevel, selectedKeywords);

    setTimeout(() => {
      // if (currentMinGranularityLevel > minValue) {
      //   setGranularityLevel(currentMinGranularityLevel - step);
      // }
      if (granularityLevelQueue.length > 0) {
        setGranularityLevel(
          granularityLevelQueue[granularityLevelQueue.length - 1]
        );
      }
    }, 100);

    temporaryDisableButton();

    setSelectedKeywords(
      selectedKeywordsQueue.length === 1
        ? []
        : selectedKeywordsQueue[selectedKeywordsQueue.length - 2]
    );
    setSelectedKeywordsQueue(selectedKeywordsQueue.slice(0, -1));
    setGranularityLevelQueue(granularityLevelQueue.slice(0, -1));
  };

  return (
    <div className={styles["granularity-zoom-buttons"]}>
      <Space.Compact block>
        <Tooltip title="Zoom In">
          <Button //style={{ background: mainColor, color: "white" }}
            disabled={isAtMax || isLoading || isNoKeywordLeft} // {isAtMax || isNoKeywordLeft || !buttonClickable || isZoomInTransition || isZoomOutTransition}
            onClick={handleIncrease}
            icon={<PlusOutlined />}
          />
        </Tooltip>
        <Tooltip title="Zoom Out">
          <Button //style={{ background: mainColor, color: "white" }}
            disabled={isAtMin || isLoading} //{isAtMin || !buttonClickable || isZoomOutTransition || isZoomInTransition}
            onClick={handleDecrease}
            icon={<MinusOutlined />}
          />
        </Tooltip>
      </Space.Compact>
    </div>
  );
};

export default GranularityZoomButtons;
